<template>
  <div class="bgc yangben">
    <div class="yangben_title title">样本数</div>
    <div class="yangben_text">
      县：{{yangBenShuData.aData}} 个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      乡/镇/社区：{{yangBenShuData.bData}}个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      村：{{yangBenShuData.cData}}个</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      yangBenData: [],
      yangBenLength: [],

      yangBenShuData: {
        aData: 0,
        bData: 0,
        cData: 0,
      },
    }
  },
  mounted() {
    this.getShenList()
  },
  methods: {
    getShenList () {
      var date = JSON.parse(localStorage.getItem("date"))
      console.log(date);
      // 样本分布地区
      let data = date.map(function (elem) {
        return elem.region;
      }).join("、");
      this.yangBenData = data.split('、')
      console.log(this.yangBenData)
      // 样本分布地区数据
      this.yangBenLength = date.map(function (elem) {
        return parseInt(elem.slist.length)
      })
      // 样本数
      var b = []
      date.forEach(element => {
        var a = element.slist.map(function (elem) {
          return elem.region_burg;
        });
        b.push(a)
      })

      var c = []
      for (let i = 0; i < b.length; i++)
      {
        for (var ii in b[i])
        {
          c.push(b[i][ii]);
        }
      }
      var d = c.join("、")

      for (let i = 0; i < d.length; i++)
      {
        if (d[i] === '村')
        {
          this.yangBenShuData.cData++
        }
        if (d[i] === '乡' || d[i] === '镇' || d[i] === '社区')
        {
          this.yangBenShuData.bData++
        }
        if (d[i] === '县' || d[i] === '市')
        {
          this.yangBenShuData.aData++
        }
      }
      console.log(this.yangBenShuData);
    },
  },
}
</script>

<style lang="less" scoped>
.yangben {
  position: absolute;
  top: 0;
  left: 0;
  width: 34%;
  height: 9vh;
  margin: 7vh 0 0 1vh;
  .yangben_title {
    text-align: center;
    padding: 1vh;
    border-bottom: 2px solid #666;
    margin: 0 5%;
  }

  .yangben_text {
    padding: 1vh;
    text-align: center;
  }
}
</style>